import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取操作记录列表
 * @param {*} params 
 * @returns 
 */
export function getOperationRecord(params) {
    let data = qs.stringify(params);
    return request({
        url: '/api/manager/operationrecord/getoperationrecords',
        method: 'post',
        data: data
    })
}

/**
 * 添加操作记录
 * @param {*} params 
 * @returns 
 */
export function addOperationRecord(params) {
    let data = qs.stringify(params);
    return request({
        url: '/api/manager/operationrecord/addoperationrecords',
        method: 'post',
        data: data
    })
}